import axios, { AxiosResponse } from "axios";
import { DataTableInterface } from "@customTypes/DataTableTypes";
import ApiResourceResponseInterface = App.Pagination.ApiResourceResponseInterface;
import DriverResource = App.Resource.DriverResource;

export default class Driver {
    static async index(params: Partial<DataTableInterface> | { active: boolean, is_active_now?: boolean | undefined, employment_types?: string[] }): Promise<AxiosResponse<ApiResourceResponseInterface<DriverResource[]>>> {
        return await axios.get<ApiResourceResponseInterface<DriverResource[]>>(route('api.drivers.index', params));
    }

    static async show(driverUuid: string) {
        return await axios.get<DriverResource>(route("api.drivers.show", { driver: driverUuid }));
    }

    static async showChatDetails(driverUuid: string) {
        return await axios.get<Pick<DriverResource, "uuid" | "name" | "given_names" | "last_name" | "full_name" | "push_notification_token">>(route("api.drivers.chat-details", { driver: driverUuid }));
    }

    static async search(params:{ query: string, amount?: number, active: boolean, page?: number, is_active_now?: boolean | undefined, location_ids?: string[], employment_types?: string[]}): Promise<AxiosResponse<ApiResourceResponseInterface<DriverResource[]>>> {
        return await axios.get<ApiResourceResponseInterface<DriverResource[]>>(route('api.drivers.search', params));
    }

    static async logout(driver:DriverResource) {
        return await axios.post(route("api.drivers.logout"), { driver: driver.uuid,})
    }

    static async uuids(params: Partial<DataTableInterface>): Promise<AxiosResponse<ApiResourceResponseInterface<DriverResource[]>>> {
        return await axios.get<ApiResourceResponseInterface<DriverResource[]>>(route('api.drivers.uuids', params));
    }

    static async send(uuids: string[], message:string): Promise<AxiosResponse<ApiResourceResponseInterface<DriverResource[]>>> {
        return await axios.post<ApiResourceResponseInterface<DriverResource[]>>(route('api.drivers.message.bulk-send'), { uuids: uuids, message:message } );
    }
}
